export const disabledCountryCodes = ['IN'];
